// Port of api/fuel/app/classes/controller/api/monty/custom/nesting/restore.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import Collection from 'offline/model/collection'
import { currentUser, persist, unauthorised, touchUser } from '../shared'

export default function(params) {
	var user = currentUser(params)
	if (!user) return unauthorised()

	var collectionId = parseInt(params.id, 10) || 0
	var collection = Collection.record({
		where: {
			user_id: user.get_id(),
			collection_id: collectionId
		}
	})

	if (!collection) return unauthorised()

	DB.run('UPDATE collection SET collection_nested = ?, collection_nested_custom = 0 WHERE collection_id = ?', [
		Constants.NESTED_OFFICIAL,
		collection.get_id()
	])

	touchUser(user)
	return persist({})
}
